module.exports = __webpack_public_path__ + "img/icon_sm_ecjc.30d8d165.png";